export default __webpack_public_path__ + "static/media/budget-tracker.82a0eac7.jpg";